import React from 'react'
import PropTypes from 'prop-types'
import Grid from 'material-ui/Grid'
import Paper from 'material-ui/Paper'
import Hidden from 'material-ui/Hidden'
import GridList, {GridListTile} from 'material-ui/GridList'
import Typography from 'material-ui/Typography'
import {Button, LoadingIndicator} from '../../../components'

import {item as text} from '../text'
import Container from '../../../common/components/Container'
import ErrorMessage from '../../../common/components/ErrorMessage'
import HeaderProgress from '../../../common/components/HeaderProgress'
import Checkbox from 'material-ui/Checkbox'
import {FormGroup, FormControlLabel} from 'material-ui/Form'
import TextField from 'material-ui/TextField'
import {RENT_AVAILABLE} from "../../../App"
import Dialog, {DialogTitle, DialogActions, DialogContent, DialogContentText} from 'material-ui/Dialog'

class Item extends React.Component {

  state = {
    picture: '',
    openDialog: false,
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.item.size === 0 && nextProps.item.size !== 0) {
      const mainPicture = nextProps.item.get('Photos').find(picture => picture.MainPhoto === true)
      this.setState({
        picture: mainPicture.Url,
      })
    }
  }

  handleCloseDialog = () => {
    this.setState({
      openDialog: false,
    })
  }

  handleOpenDialog = () => {
    this.setState({
      openDialog: true,
    })
  }

  getTiles = w => {
    return this.props.item.get('Photos').map(picture => {
      return picture.Url + `?fit=fill&h=100&w=${w}`
    })
  }

  handleTileClick = url => {
    this.setState({picture: url.substring(0, url.indexOf('?'))})
  }

  renderCost = cost => {
    return <span>${cost}/día</span>
  }

  getMainImageSize = width => {
    switch (width) {
      case 'xs':
        return 400
      case 'sm':
        return 550
      case 'md':
        return 431
      case 'lg':
        return 594
      case 'xl':
        return 594
      default:
        return 594
    }
  }

  getSmallImageSize = width => {
    switch (width) {
      case 'xs':
        return 131
      case 'sm':
        return 135
      case 'md':
        return 105
      case 'lg':
        return 116
      case 'xl':
        return 116
      default:
        return 146
    }
  }

  getCols = width => {
    switch (width) {
      case 'xs':
        return 3
      case 'sm':
        return 4
      case 'md':
        return 4
      case 'lg':
        return 5
      case 'xl':
        return 5
      default:
        return 3
    }
  }

  renderRentConfig = classes => (
      <div>
        <div style={{display: 'flex'}}>
          <div style={{flex: 1}}>
            <Typography variant={'body2'}>{text.rentItem}</Typography>
            <Typography variant={'body1'}>{this.props.forRent ? text.itemForRent : text.itemNotForRent}</Typography>
          </div>
          <div>
            <FormGroup row>
              <FormControlLabel
                  control={
                    <Checkbox
                        checked={this.props.forRent}
                        value="forRent"
                        onChange={() => this.props.setForRent(!this.props.forRent)}
                    />
                  }
                  label={text.labelForRent}
              />
            </FormGroup>
          </div>
        </div>
        {this.props.forRent === false ? null : (
            <Paper style={{padding: 16, margin: 16}}>
              <Typography variant={'body1'} align={'center'}>{text.rentForHowMuch}</Typography>
              <div style={{display: 'flex', justifyContent: 'center'}}>
                <Typography variant={'title'} color={'primary'} style={{marginTop: 7}}>$</Typography>
                <TextField
                    type={'number'}
                    className={classes.priceInputContainer}
                    inputProps={{
                      className: classes.priceInput,
                    }}
                    value={this.props.price}
                    onChange={(e) => this.props.setPrice(e.target.value)}
                />
                <Typography variant={'title'} color={'primary'} style={{marginTop: 7}}>{text.perDay}</Typography>
              </div>
            </Paper>
        )}
        <div style={{paddingTop: 16}}>
          <LoadingIndicator show={this.props.isSaving}>
            <Button variant={'primary'} fullWidth={true} onClick={this.props.save}>{text.save}</Button>
          </LoadingIndicator>
        </div>
      </div>
  )

  render() {
    const {classes, width, item, error, isFetching} = this.props
    if (error !== '') return <ErrorMessage error={error}/>
    if (isFetching === true) return <HeaderProgress show={true}/>
    if (item.size === 0) return <ErrorMessage error={text.somethingWentWrong}/>

    const rentConfig = RENT_AVAILABLE
        ? this.renderRentConfig(classes)
        : null

    return (
      <Container>
        <HeaderProgress show={isFetching}/>
        <Grid container spacing={0} style={{padding: width === 'lg' || width === 'xl' ? '0 160px' : 0}}>
          <Grid item xs={12} md={6}>
            <Hidden only={['xs']}>
              <Paper style={{minHeight: 400}}>
                <img
                  src={`${this.state.picture}?fit=fill&h=400&w=${this.getMainImageSize(width)}`}
                  alt={item.get('Name')}
                  width="100%"
                  height="400"
                  style={{objectFit: 'cover'}}
                />
              </Paper>
            </Hidden>
            <Hidden only={['sm', 'md', 'lg', 'xl']}>
              <Paper style={{minHeight: 320}}>
                <img
                  src={`${this.state.picture}?fit=fill&h=320&w=${this.getMainImageSize(width)}`}
                  alt={item.get('Name')}
                  width="100%"
                  height="320"
                  style={{objectFit: 'cover'}}
                />
              </Paper>
            </Hidden>
            <div className={classes.imgListContainer}>
              <GridList cols={this.getCols(width)} cellHeight={90} className={classes.imgList}>
                {this.getTiles(this.getSmallImageSize(width)).map((tile, key) => (
                  <GridListTile
                    key={key}
                    onClick={() => this.handleTileClick(tile)}
                    classes={{
                      root: classes.gridListTileRoot,
                      tile: classes.gridListTileTile,
                    }}
                  >
                    <Paper style={{width: '100%', height: '100%'}}>
                      <img src={tile} alt={tile} width={'100%'} height={'100%'} style={{objectFit: 'scale-down'}}/>
                    </Paper>
                  </GridListTile>
                ))}
              </GridList>
            </div>
          </Grid>
          <Grid item xs={12} md={6} style={{padding: 0}}>
            <div className={classes.itemDescriptionContainer}>
              <div>
                <TextField
                  value={this.props.name}
                  onChange={(e) => this.props.setName(e.target.value)}
                  inputProps={{className: classes.nameInput}}
                  fullWidth={true}
                />
                <Typography variant="body2" gutterBottom color={'textSecondary'}>{item.get('Product')}</Typography>
                <TextField
                  value={this.props.description}
                  onChange={(e) => this.props.setDescription(e.target.value)}
                  inputProps={{className: classes.descriptionInput}}
                  multiline={true}
                  fullWidth={true}
                />
                <div style={{marginTop: 15, padding: '20px 0'}}>
                  <Button
                    variant="primary"
                    onClick={() => this.handleOpenDialog()}
                    fullWidth={true}
                  >
                    {text.requestRemoval}
                  </Button>
                </div>
              </div>
              {rentConfig}
            </div>
          </Grid>
        </Grid>
        <Dialog open={this.state.openDialog} onClose={this.handleCloseDialog} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" >
          <DialogTitle id="alert-dialog-title">Solicitar devolución</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Debido a la alta demanda de solicitudes, te pedimos que te comuniques con uno de nuestros asesores
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseDialog} color="primary" autoFocus>
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    )
  }
}

Item.propTypes = {
  isFetching: PropTypes.bool,
  isSaving: PropTypes.bool,
  error: PropTypes.string,
  item: PropTypes.object,
  startRemove: PropTypes.func.isRequired,
  forRent: PropTypes.bool.isRequired,
  price: PropTypes.string.isRequired,
  setForRent: PropTypes.func.isRequired,
  setPrice: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  setName: PropTypes.func.isRequired,
  setDescription: PropTypes.func.isRequired,
  save: PropTypes.func.isRequired,
}

export default Item



// WEBPACK FOOTER //
// ./src/sections/yourItems/components/item.js